var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2444_9416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0879 11.7897V19.8262H50.6605L41.8605 11.0262L41.0879 11.7897Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.318 55.5383C28.8848 55.5383 34.2083 50.2148 34.2083 43.648C34.2083 37.0812 28.8848 31.7577 22.318 31.7577C15.7512 31.7577 10.4277 37.0812 10.4277 43.648C10.4277 50.2148 15.7512 55.5383 22.318 55.5383Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3383 18.9239V12.7916L48.4706 18.9239H42.3383ZM52.6642 19.7487C52.7149 19.8893 52.7396 20.0371 52.7383 20.1848V51.4836C52.7383 52.174 52.1787 52.7336 51.4883 52.7336H37.8426C37.1523 52.7336 36.5926 52.174 36.5926 51.4836C36.5926 50.7933 37.1523 50.2336 37.8426 50.2336H50.2383V21.4239H41.0883C40.398 21.4239 39.8383 20.8643 39.8383 20.1739V11.0239H19.248V27.0631C19.248 27.7534 18.6884 28.3131 17.998 28.3131C17.3077 28.3131 16.748 27.7534 16.748 27.0631V9.77393C16.748 9.08357 17.3077 8.52393 17.998 8.52393H41.0883H41.0884C41.2498 8.52393 41.404 8.55452 41.5456 8.61023C41.701 8.67119 41.8467 8.76447 41.9723 8.89004L52.3723 19.29C52.5064 19.4242 52.6037 19.5813 52.6642 19.7487ZM11.6777 43.6481C11.6777 37.7716 16.4416 33.0078 22.318 33.0078C28.1945 33.0078 32.9583 37.7716 32.9583 43.6481C32.9583 49.5246 28.1945 54.2884 22.318 54.2884C16.4416 54.2884 11.6777 49.5246 11.6777 43.6481ZM22.318 30.5078C15.0608 30.5078 9.17773 36.3909 9.17773 43.6481C9.17773 50.9053 15.0608 56.7884 22.318 56.7884C29.5752 56.7884 35.4583 50.9053 35.4583 43.6481C35.4583 36.3909 29.5752 30.5078 22.318 30.5078Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2491 41.5955H18.3863C17.7096 41.5955 17.1611 42.144 17.1611 42.8206V48.9966C17.1611 49.6732 17.7096 50.2217 18.3863 50.2217H26.2491C26.9258 50.2217 27.4743 49.6732 27.4743 48.9966V42.8206C27.4743 42.144 26.9258 41.5955 26.2491 41.5955Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3176 38.3243C21.466 38.3243 20.7744 39.014 20.7744 39.8675V42.4869C20.7744 43.1773 20.2148 43.7369 19.5244 43.7369C18.8341 43.7369 18.2744 43.1773 18.2744 42.4869V39.8675C18.2744 37.6307 20.088 35.8243 22.3176 35.8243C24.5544 35.8243 26.3607 37.6379 26.3607 39.8675V42.4869C26.3607 43.1773 25.8011 43.7369 25.1107 43.7369C24.4203 43.7369 23.8607 43.1773 23.8607 42.4869V39.8675C23.8607 39.0159 23.171 38.3243 22.3176 38.3243Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3174 44.1794C22.8697 44.1794 23.3174 44.6272 23.3174 45.1794V47.4377C23.3174 47.99 22.8697 48.4377 22.3174 48.4377C21.7651 48.4377 21.3174 47.99 21.3174 47.4377V45.1794C21.3174 44.6272 21.7651 44.1794 22.3174 44.1794Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2444_9416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedFile);
export default __webpack_public_path__ + "static/media/locked-file.0e0849a126f89894360eba104251a893.svg";
export { ForwardRef as ReactComponent };